import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1750. 受注案件契約タスクファイル削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/sales_order_contract_tasks/:sales_order_contract_task_id/sales_order_contract_task_documents/:sales_order_contract_task_document_id
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  id: number;
};

const destroySalesOrderContractTaskDocument = (props: Props) => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/sales_order_contract_tasks/${props.task_id}/sales_order_contract_task_documents/${props.id}`
  );
};

export const useDestroySalesOrderContractTaskDocument = () => {
  return useMutation({
    mutationFn: destroySalesOrderContractTaskDocument
  });
};